const STORAGE_PREFIX = 'ofrontend.bookingPricingType.';

export function saveBookingPricingTypePreference(bookingId: string, pricingTypeId: number): void {
  const id = bookingId.trim();
  if (!id || !Number.isFinite(pricingTypeId)) {
    return;
  }
  try {
    sessionStorage.setItem(`${STORAGE_PREFIX}${id}`, String(Math.floor(pricingTypeId)));
  } catch {
    /* private mode / quota */
  }
}

export function loadBookingPricingTypePreference(bookingId: string): number | null {
  const id = bookingId.trim();
  if (!id) {
    return null;
  }
  try {
    const raw = sessionStorage.getItem(`${STORAGE_PREFIX}${id}`);
    if (raw === null || !raw.trim()) {
      return null;
    }
    const n = Number(raw.trim());
    return Number.isFinite(n) ? n : null;
  } catch {
    return null;
  }
}
